import React from "react";
import Select, { Creatable, components } from "react-select";
import AsyncSelect from "react-select/async";
import NumberFormat from "react-number-format";
import classNames from "classnames";
import Switch from "react-switch";
import DayPicker from "../DayPicker";
import FileUploader from "../FileUploader/FileUploader";
import DatePicker from "react-datepicker";
import _ from "lodash";
import TimePicker from "react-time-picker";
import TagsInput from "react-tagsinput";
import moment from "moment";

export const renderField = ({
    input,
    placeholder,
    type,
    disabled,
    addClass,
    style,
    meta: { touched, error },
}) => {
    const invalid = touched && error;
    return (
        <div>
            <input
                {...input}
                placeholder={placeholder}
                disabled={disabled}
                type={type}
                style={style}
                className={classNames(
                    "form-control",
                    { "is-invalid": invalid },
                    addClass
                )}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderTextArea = ({
    input,
    placeholder,
    disabled,
    rows,
    meta: { touched, error },
}) => {
    const invalid = touched && error;
    return (
        <div>
            <textarea
                {...input}
                placeholder={placeholder}
                disabled={disabled}
                style={{ resize: "none" }}
                rows={rows || 3}
                className={classNames("form-control", {
                    "is-invalid": invalid,
                })}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderCM2 = ({
    input,
    decimalScale,
    placeholder,
    meta: { touched, error },
    prefix = "",
    suffix = "cm2",
    numberFormat,
}) => {
    const invalid = touched && error;
    return (
        <div>
            <NumberFormat
                placeholder={placeholder}
                className={classNames("form-control", {
                    "is-invalid": invalid,
                })}
                decimalScale={decimalScale || 0}
                format={numberFormat}
                fixedDecimalScale
                value={input.value}
                thousandSeparator
                prefix={prefix}
                suffix={suffix}
                onValueChange={(values) => {
                    input.onChange(values.value);
                }}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderNumber = ({
    input,
    decimalScale,
    placeholder,
    meta: { touched, error },
    prefix = "",
    suffix = "",
    numberFormat,
}) => {
    const invalid = touched && error;
    return (
        <div>
            <NumberFormat
                placeholder={placeholder}
                className={classNames("form-control", {
                    "is-invalid": invalid,
                })}
                decimalScale={decimalScale || 0}
                format={numberFormat}
                fixedDecimalScale
                value={input.value}
                thousandSeparator
                prefix={prefix}
                suffix={suffix}
                onValueChange={(values) => {
                    input.onChange(values.value);
                }}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderNumberBill = ({
    input,
    decimalScale,
    placeholder,
    meta: { touched, error, dirty },
    prefix = "",
    suffix = "",
    numberFormat,
    onCambio,
    disabled,
}) => {
    const invalid = error ? true : false;
    return (
        <div>
            <NumberFormat
                placeholder={placeholder}
                className={classNames("form-control", {
                    "is-invalid": invalid,
                })}
                decimalScale={decimalScale || 0}
                format={numberFormat}
                fixedDecimalScale
                disabled={disabled}
                value={input.value}
                prefix={prefix}
                suffix={suffix}
                onValueChange={(values) => {
                    input.onChange(values.value);
                    if (!!onCambio) {
                        onCambio(values.floatValue);
                    }
                }}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderNumberPercentage = ({
    input,
    decimalScale,
    placeholder,
    meta: { touched, error, dirty },
    prefix = "",
    numberFormat,
    onCambio,
    disabled,
    allowNegative,
    onBlur,
}) => {
    const invalid = error ? true : false;
    return (
        <div style={{ textAlign: "right" }}>
            <NumberFormat
                placeholder={placeholder}
                className={classNames("form-control", {
                    "is-invalid": invalid,
                })}
                decimalScale={decimalScale || 2}
                format={numberFormat}
                fixedDecimalScale
                disabled={disabled}
                value={input.value}
                thousandSeparator
                prefix={prefix}
                suffix=" %"
                allowNegative={allowNegative}
                style={{ textAlign: "right" }}
                onValueChange={(values) => {
                    input.onChange(values.value);
                    if (!!onCambio) {
                        onCambio(values.floatValue);
                    }
                }}
                onBlur={() => {
                    input.onBlur(input.value);
                    if (onBlur) {
                        onBlur();
                    }
                }}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderNumberPercentageFixed = ({
    input,
    decimalScale,
    placeholder,
    meta: { touched, error, dirty },
    prefix = "",
    numberFormat,
    onCambio,
    disabled,
}) => {
    const invalid = error ? true : false;
    return (
        <div>
            <NumberFormat
                placeholder={placeholder}
                className={classNames("form-control", {
                    "is-invalid": invalid,
                })}
                decimalScale={decimalScale || 2}
                format={numberFormat}
                fixedDecimalScale
                disabled={disabled}
                value={input.value}
                thousandSeparator
                prefix={prefix}
                suffix=" %"
                onValueChange={(values) => {
                    input.onChange(values.value);
                    if (!!onCambio) {
                        onCambio(values.floatValue);
                    }
                }}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderNumberKG = ({
    input,
    placeholder = "0.00 kg",
    decimalScale = 2,
    meta: { touched, error },
    suffix = " kg",
    numberFormat,
    onCambio,
    disabled,
    isReport = false,
}) => {
    const invalid = touched && error;

    const inputClass = classNames("form-control text-right", {
        "is-invalid": invalid,
        "report-input-kg": isReport, // Agrega esta clase solo si es modo reporte
    });

    return (
        <div className="input-kg-wrapper">
            <NumberFormat
                placeholder={placeholder}
                className={inputClass}
                decimalScale={decimalScale}
                fixedDecimalScale
                disabled={disabled}
                value={input.value}
                thousandSeparator
                suffix={suffix}
                onValueChange={(values) => {
                    input.onChange(values.value);
                    if (onCambio) {
                        onCambio(values.floatValue);
                    }
                }}
                onBlur={() => {
                    input.onBlur(input.value);
                }}
            />

            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderNumberUnits = ({
    input,
    placeholder,
    decimalScale,
    meta: { touched, error },
    prefix = "",
    numberFormat,
    onCambio,
    disabled,
}) => {
    // Espera a que el campo sea 'tocado' para verificar si tiene algún error de validación
    const invalid = touched && error;
    return (
        <div>
            <NumberFormat
                placeholder={placeholder}
                className={classNames("form-control", {
                    "is-invalid": invalid,
                })}
                decimalScale={decimalScale || 2}
                format={numberFormat}
                fixedDecimalScale
                disabled={disabled}
                value={input.value}
                thousandSeparator
                prefix={prefix}
                suffix="  U"
                onValueChange={(values) => {
                    input.onChange(values.value);
                    if (!!onCambio) {
                        onCambio(values.floatValue);
                    }
                }}
                onBlur={() => {
                    input.onBlur(input.value);
                }}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};
export const renderNumberKGDisabled = ({
    input,
    placeholder,
    decimalScale,
    meta: { touched, error },
    prefix = "",
    numberFormat,
    onCambio,
}) => {
    // Espera a que el campo sea 'tocado' para verificar si tiene algún error de validación
    const invalid = touched && error;
    return (
        <div style={{ textAlign: "right" }}>
            <NumberFormat
                placeholder={placeholder}
                decimalScale={decimalScale || 2}
                format={numberFormat}
                fixedDecimalScale
                value={input.value}
                thousandSeparator
                displayType="text"
                suffix=" kg"
                style={{
                    minWidth: "100px",
                }}
                onValueChange={(values) => {
                    input.onChange(values.value);
                    if (!!onCambio) {
                        onCambio(values.floatValue);
                    }
                }}
                onBlur={() => {
                    input.onBlur(input.value);
                }}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};
export const renderNumberDisabled = ({
    input,
    placeholder,
    decimalScale,
    meta: { touched, error },
    prefix,
    suffix,
    numberFormat,
    onCambio,
}) => {
    // Espera a que el campo sea 'tocado' para verificar si tiene algún error de validación
    const invalid = touched && error;
    return (
        <div>
            <NumberFormat
                placeholder={placeholder}
                className={classNames("form-control-disabled", {
                    "is-invalid": invalid,
                })}
                decimalScale={decimalScale || 2}
                format={numberFormat}
                fixedDecimalScale
                value={input.value}
                style={{ border: "0", textAlign: "center" }}
                thousandSeparator
                prefix={prefix ? prefix : ""}
                suffix={suffix ? suffix : ""}
                onValueChange={(values) => {
                    input.onChange(values.value);
                    if (!!onCambio) {
                        onCambio(values.floatValue);
                    }
                }}
                onBlur={() => {
                    input.onBlur(input.value);
                }}
                disabled
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderNumberCM = (props) => {
    const {
        input,
        placeholder,
        decimalScale,
        meta: { touched, error },
        prefix = "",
        numberFormat,
        onCambio,
        disabled,
    } = props;
    const invalid = touched && error;
    return (
        <div>
            <NumberFormat
                placeholder={placeholder}
                className={classNames("form-control", {
                    "is-invalid": invalid,
                })}
                decimalScale={decimalScale !== undefined ? decimalScale : 2}
                format={numberFormat}
                fixedDecimalScale
                disabled={disabled}
                value={input.value}
                thousandSeparator
                prefix={prefix}
                suffix=" cm"
                onValueChange={(values) => {
                    input.onChange(values.value);
                    if (!!onCambio) {
                        onCambio(values.floatValue);
                    }
                }}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderNumberG = ({
    input,
    placeholder,
    decimalScale,
    meta: { touched, error },
    prefix = "",
    numberFormat,
    onCambio,
    disabled,
}) => {
    const invalid = touched && error;
    return (
        <div>
            <NumberFormat
                placeholder={placeholder}
                className={classNames("form-control", {
                    "is-invalid": invalid,
                })}
                decimalScale={decimalScale || 4}
                format={numberFormat}
                fixedDecimalScale
                disabled={disabled}
                value={input.value}
                thousandSeparator
                prefix={prefix}
                suffix=" g"
                onValueChange={(values) => {
                    input.onChange(values.value);
                    if (!!onCambio) {
                        onCambio(values.floatValue);
                    }
                }}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderNumberML = ({
    input,
    placeholder,
    decimalScale,
    meta: { touched, error },
    prefix = "",
    numberFormat,
    onCambio,
    disabled,
}) => {
    const invalid = touched && error;
    return (
        <div>
            <NumberFormat
                placeholder={placeholder}
                className={classNames("form-control", {
                    "is-invalid": invalid,
                })}
                decimalScale={decimalScale || 4}
                format={numberFormat}
                fixedDecimalScale
                disabled={disabled}
                value={input.value}
                thousandSeparator
                prefix={prefix}
                suffix=" ml"
                onValueChange={(values) => {
                    input.onChange(values.value);
                    if (!!onCambio) {
                        onCambio(values.floatValue);
                    }
                }}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderCurrency = ({
    input,
    meta: { touched, error },
    prefix = "Q. ",
    placeholder,
    disabled,
    decimalScale,
    highlightNegative = false,
    style,
    isSalida = false
}) => {
    const invalid = touched && error;
    const isNegative = highlightNegative && parseFloat(input.value) < 0;

    return (
        <div>
            <NumberFormat
                className={classNames("form-control", {
                    "is-invalid": invalid,
                })}
                decimalScale={decimalScale ? decimalScale : 2}
                fixedDecimalScale
                placeholder={placeholder}
                value={input.value}
                thousandSeparator
                style={{
                    minWidth: "100px",
                    textAlign: "right",
                    ...style,
                    color: isNegative ? "#dc3545" : undefined,
                    fontWeight: isNegative ? "500" : "normal",
                    backgroundColor: isSalida ? '#fff5f5' : undefined,
                    borderColor: isSalida ? '#dc3545' : undefined
                }}
                disabled={disabled}
                prefix={prefix}
                onValueChange={(values) => {
                    input.onChange(values.value);
                }}
                onBlur={() => {
                    let val = parseFloat(input.value) || 0;
                    if (isSalida && val > 0) {
                        val = -val;
                    }
                    input.onBlur(val.toString());

                }}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};


export const renderCurrencyDisabled = ({
    input,
    meta: { touched, error },
    prefix = "Q. ",
    placeholder,
    decimalScale,
    disabledStyle,
}) => {
    const invalid = touched && error;
    const scale = 
        decimalScale !== undefined && decimalScale !== null ? decimalScale : 2;
    
    return (
        <div style={{ textAlign: "right" }}>
            <NumberFormat
                {...input}
                placeholder={placeholder}
                style={{
                    border: "0",
                    ...disabledStyle,
                    minWidth: "100px",
                    whiteSpace: "nowrap",
                }}
                prefix={prefix}
                thousandSeparator
                fixedDecimalScale
                decimalScale={scale}
                className={classNames("form-control-disabled", {
                    "is-invalid": invalid,
                })}
                displayType="text"
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};
export const renderCurrencyDisabledWhithNegative = ({
    input,
    meta: { touched, error },
    prefix = "Q. ",
    placeholder,
    decimalScale,
}) => {
    const invalid = touched && error;
    const isNegative = parseFloat(input.value) < 0;

    return (
        <div style={{ textAlign: "right" }}>
            <NumberFormat
                decimalScale={decimalScale ? decimalScale : 2}
                fixedDecimalScale
                placeholder={placeholder}
                value={input.value}
                thousandSeparator
                displayType="text"
                style={{
                    border: "0",
                    color: isNegative ? "red" : "",
                    minWidth: "100px",
                    whiteSpace: "nowrap",
                }}
                prefix={prefix}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderToneladasDisabled = ({
    input,
    placeholder,
    meta: { touched, error },
    decimalScale,
}) => {
    const invalid = touched && error;
    return (
        <div>
            <NumberFormat
                className={classNames("form-control-disabled", {
                    "is-invalid": invalid,
                })}
                decimalScale={decimalScale ? decimalScale : 2}
                fixedDecimalScale
                placeholder={placeholder}
                value={input.value / 1000}
                thousandSeparator
                suffix=" TM"
                readOnly
                style={{ textAlign: "right" }}
                displayType="text"
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderNumeroSinFormato = ({
    input,
    meta: { touched, error },
    placeholder,
    disabled,
    decimalScale,
}) => {
    const invalid = touched && error;
    return (
        <div>
            <NumberFormat
                className={classNames("form-control", {
                    "is-invalid": invalid,
                })}
                decimalScale={decimalScale ? decimalScale : 2}
                fixedDecimalScale
                placeholder={placeholder}
                value={input.value}
                thousandSeparator
                disabled={disabled}
                // prefix={prefix}
                onValueChange={(values) => {
                    input.onChange(values.value);
                }}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};
export const renderDollarSiDecimal = ({
    input,
    decimalScale,
    placeholder,
    meta: { touched, error, dirty },
    prefix = "$ ",
    numberFormat,
    onCambio,
    disabled,
}) => {
    const invalid = touched && error;
    return (
        <div>
            <NumberFormat
                placeholder={placeholder}
                className={classNames("form-control", {
                    "is-invalid": invalid,
                })}
                decimalScale={decimalScale || 0}
                format={numberFormat}
                fixedDecimalScale
                disabled={disabled}
                value={input.value}
                thousandSeparator
                prefix={prefix}
                // suffix="$ "
                onValueChange={(values) => {
                    input.onChange(values.value);
                    if (!!onCambio) {
                        onCambio(values.floatValue);
                    }
                }}
                onBlur={() => {
                    input.onBlur(input.value);
                }}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderDollar = ({
    input,
    meta: { touched, error },
    placeholder,
    disabled,
    prefix = "$ ",
    decimalScale = 2,
    style,
    isSalida
}) => {
    const invalid = touched && error;
    const numericValue = parseFloat(input.value) || 0;
    const isNegative = numericValue < 0 || isSalida;

    return (
        <div>
            <NumberFormat
                className={classNames("form-control", {
                    "is-invalid": invalid,
                })}
                decimalScale={decimalScale}
                fixedDecimalScale
                placeholder={placeholder}
                value={input.value}
                thousandSeparator
                style={{
                    minWidth: "100px",
                    textAlign: "right",
                    ...style,
                    color: isNegative ? "#dc3545" : undefined,
                    fontWeight: isNegative ? "500" : "normal",
                    backgroundColor: isSalida ? '#fff5f5' : undefined,
                    borderColor: isSalida ? '#dc3545' : undefined
                }}
                disabled={disabled}
                prefix={prefix}
                allowNegative={true}
                onValueChange={(values) => {
                    input.onChange(values.value);
                }}
                onBlur={() => {
                    let val = parseFloat(input.value) || 0;
                    if (isSalida && val > 0) {
                        val = -val;
                    }
                    input.onBlur(val.toString());
                }}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderSwitch = ({
    input,
    meta: { touched, error },
    label,
    disabled,
    checked,
}) => {
    const invalid = touched && error;
    return (
        <div className="d-flex align-items-center">
            <Switch
                offColor="#888"
                onColor="#035B2F"
                height={24}
                width={52}
                disabled={disabled}
                onChange={(value) => {
                    input.onChange(value);
                }}
                checked={
                    checked !== undefined
                        ? checked
                        : input.value
                        ? input.value
                        : false
                }
                id="normal-switch"
                handleDiameter={18}
                uncheckedIcon={
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            fontSize: 12,
                            color: "#fff",
                            paddingRight: 2,
                        }}
                    >
                        No
                    </div>
                }
                checkedIcon={
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            fontSize: 12,
                            color: "#fff",
                            paddingLeft: 2,
                        }}
                    >
                        Si
                    </div>
                }
            />
            &nbsp;{label}
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderSwitchMessage = ({ input, message }) => {
    return (
        <div className="d-flex align-items-center">
            <Switch
                onColor="#007bff"
                height={18}
                width={36}
                onChange={(value) => {
                    input.onChange(value);
                }}
                checked={input.value ? input.value : false}
            />
        </div>
    );
};

export const renderFieldCheck = ({
    input,
    label,
    disabled,
    onChange,
    meta: { touched, error },
}) => {
    // ...

    return (
        <div className="checkbox c-checkbox">
            <label className="needsclick">
                <input
                    type="checkbox"
                    disabled={disabled}
                    {...input}
                    checked={input.value ? true : false}
                />
                {label}&nbsp;
                <span className="fa fa-check ml-2" />
            </label>
        </div>
    );
};

export const renderFieldCheckOne = ({
    input,
    label,
    type,
    meta: { touched, error },
    customOnChange,
}) => {
    return (
        <div className="checkbox c-checkbox">
            <label className="needsclick">
                <input
                    type={type}
                    {...input}
                    onChange={(event) => {
                        // Actualiza el valor del checkbox
                        input.onChange(event.target.checked);

                        // Luego, si se proporciona una función customOnChange, la llama con el nombre del campo y el estado actual del checkbox (checked or not)
                        if (customOnChange) {
                            customOnChange(input.name, event.target.checked);
                        }
                    }}
                />
                {label}&nbsp;
                <span className="fa fa-check ml-2" />
            </label>
            {touched && error && <span className="text-danger">{error}</span>}
        </div>
    );
};

export const renderFieldRadio = ({
    input,
    label,
    value,
    id,
    disabled,
    checked,
    meta: { touched, error },
}) => {
    const invalid = touched && error;
    return (
        <React.Fragment>
            <div className="radio c-radio c-radio-nofont d-flex">
                <label className="font-weight-bold">
                    <input
                        type="radio"
                        disabled={disabled}
                        id={id}
                        value={value}
                        checked={checked}
                        {...input}
                        className={classNames("", { "is-invalid": invalid })}
                    />
                    {label}&nbsp;
                    <span />
                </label>
            </div>
            {invalid && <div className="invalid-feedback">{error}</div>}
        </React.Fragment>
    );
};
export const SelectFieldAllFields = ({
    input,
    isMulti,
    options,
    disabled,
    onCambio,
    objAsValue = true,
    onCambioObj,
    placeholder,
    isClearable,
    isSearchable,
    is_departamentos,
    labelKey = "label",
    valueKey = "value",
    meta: { touched, error, dirty },
}) => {
    const invalid = Boolean((dirty && error) || (touched && error));
    const _options = [];
    if (is_departamentos) {
        Object.keys(options).forEach((option, index) => {
            _options.push({ ...option, label: options[option], value: option });
        });
    } else {
        options.forEach((option) => {
            _options.push({
                ...option,
                label: option[labelKey],
                value: option[valueKey],
            });
        });
    }
    let value = input.value;
    if (value !== null && value !== undefined) {
        if (typeof value === "object" && objAsValue) {
            value = _options.find((option) => option.value === value[valueKey]);
        } else {
            value = _options.find((option) => option.value === value);
        }
    }
    if (value === undefined) {
        value = null;
    }
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            borderRadius: "1.5rem",
            fontSize: "12px",
            minHeight: "0",
            border: state.isFocused ? "1px solid #035192" : "1px solid #ced4da",
            boxShadow: state.isFocused
                ? "0 0 0 0.2rem rgba(3, 81, 146, 0.25)"
                : "none",
        }),
        placeholder: (provided, state) => ({
            ...provided,
            fontSize: "14px",
        }),
        indicatorContainer: (provided, state) => ({
            ...provided,
            padding: "0 8px 0 2px",
        }),
        indicatorSeparator: (provided, state) => ({
            ...provided,
            backgroundColor: "white",
        }),
        singleValue: (provided, state) => ({
            ...provided,
            fontSize: "12px",
        }),
        menu: (provided, state) => ({
            ...provided,
            fontSize: "12px",
            zIndex: 9999,
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    };

    return (
        <React.Fragment>
            <Select
                isClearable={isClearable}
                className={classNames("react-select-container", {
                    "is-invalid": invalid,
                })}
                backspaceRemovesValue={false}
                isMulti={isMulti}
                isSearchable={isSearchable}
                options={_options}
                placeholder={placeholder}
                onChange={(selectedOption) => {
                    if (objAsValue) {
                        input.onChange(selectedOption);
                    } else {
                        input.onChange(
                            selectedOption ? selectedOption[valueKey] : null
                        );
                    }
                    if (!!onCambio) {
                        onCambio(selectedOption ? selectedOption["id"] : null);
                    }
                    !!onCambioObj && onCambioObj(selectedOption);
                }}
                value={value}
                isDisabled={disabled}
                styles={customStyles}
                menuPortalTarget={document.body}
            />
            {invalid && <div className="invalid-force">{error}</div>}
        </React.Fragment>
    );
};

export const SelectField = ({
    input,
    isMulti,
    options,
    disabled,
    onCambio,
    objAsValue = false, // Si es true, a input.onChange() se pasa el item y no item[valueKey]
    onCambioObj,
    placeholder,
    isClearable,
    isSearchable,
    is_departamentos,
    labelKey = "label",
    valueKey = "value",
    meta: { touched, error, dirty },
}) => {
    const invalid = Boolean((dirty && error) || (touched && error));
    const _options = [];
    if (is_departamentos) {
        {
            Object.keys(options).forEach((option, index) => {
                _options.push({
                    ...option,
                    label: options[option],
                    value: option,
                });
            });
        }
    } else {
        options.forEach((option) => {
            _options.push({
                ...option,
                label: option[labelKey],
                value: option[valueKey],
            });
        });
    }
    let value = input.value;
    if (value !== null && value !== undefined) {
        if (typeof value === "object") {
            value = _.find(_options, { value: value[valueKey] });
        } else {
            value = _.find(_options, { value });
        }
    }
    if (value === undefined) {
        value = null;
    }
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            borderRadius: "1.5rem",
            fontSize: "12px",
            minHeight: "0",
            border: state.isFocused ? "1px solid #035192" : "1px solid #ced4da", // Ajusta el borde basado en el estado
            boxShadow: state.isFocused
                ? "0 0 0 0.2rem rgba(3, 81, 146, 0.25)"
                : "none", // Ajusta la sombra del foco
        }),
        placeholder: (provided, state) => ({
            ...provided,
            fontSize: "14px",
        }),
        indicatorContainer: (provided, state) => ({
            ...provided,
            padding: "0 8px 0 2px",
        }),
        indicatorSeparator: (provided, state) => ({
            ...provided,
            backgroundColor: "white",
        }),
        singleValue: (provided, state) => ({
            ...provided,
            fontSize: "12px",
        }),
        menu: (provided, state) => ({
            ...provided,
            fontSize: "12px",
        }),
    };
    return (
        <React.Fragment>
            <Select
                isClearable={isClearable}
                className={classNames("react-select-container", {
                    "is-invalid": invalid,
                })}
                backspaceRemovesValue={false}
                isMulti={isMulti}
                isSearchable={isSearchable}
                options={_options}
                placeholder={"Seleccione..."}
                onChange={(e) => {
                    input.onChange(e ? (objAsValue ? e : e[valueKey]) : null);
                    if (!!onCambio) {
                        onCambio(e ? e["id"] : null);
                    }
                    !!onCambioObj && onCambioObj(e);
                }}
                // onChange={(e) => { input.onChange(e ? e[valueKey] : null); }}
                value={value}
                isDisabled={disabled}
                styles={customStyles}
            />
            {invalid && <div className="invalid-force">{error}</div>}
        </React.Fragment>
    );
};
export const SelectMunicipioField = ({
    input,
    disabled,
    isClearable,
    isMulti,
    isSearchable,
    options,
    placeholder,
    labelKey = "label",
    valueKey = "value",
    meta: { touched, error },
}) => {
    const invalid = touched && error;
    const _options = [];

    {
        options.forEach((option) => {
            _options.push({
                ...option,
                label: option.nombre,
                value: option.id,
            });
        });
    }
    let value = input.value;
    if (value !== null && value !== undefined) {
        value = _.find(_options, { value });
    }
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            borderRadius: "1.5rem",
            fontSize: "12px",
            minHeight: "0",
            border: state.isFocused ? "1px solid #035192" : "1px solid #ced4da", // Ajusta el borde basado en el estado
            boxShadow: state.isFocused
                ? "0 0 0 0.2rem rgba(3, 81, 146, 0.25)"
                : "none", // Ajusta la sombra del foco
        }),
        placeholder: (provided, state) => ({
            ...provided,
            fontSize: "14px",
        }),
        indicatorContainer: (provided, state) => ({
            ...provided,
            padding: "0 8px 0 2px",
        }),
        indicatorSeparator: (provided, state) => ({
            ...provided,
            backgroundColor: "white",
        }),
        singleValue: (provided, state) => ({
            ...provided,
            fontSize: "12px",
        }),
        menu: (provided, state) => ({
            ...provided,
            fontSize: "12px",
        }),
    };
    return (
        <React.Fragment>
            <Select
                isClearable={isClearable}
                className={classNames("react-select-container", {
                    "is-invalid": invalid,
                })}
                backspaceRemovesValue={false}
                isMulti={isMulti}
                isSearchable={isSearchable}
                options={_options}
                placeholder={"Seleccione..."}
                onChange={(e) => {
                    input.onChange(e ? e[valueKey] : null);
                }}
                value={value}
                isDisabled={disabled}
                styles={customStyles}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </React.Fragment>
    );
};

export const AsyncSelectField = ({
    input,
    disabled,
    isClearable,
    isSearchable,
    loadOptions,
    placeholder,
    valueKey,
    labelKey,
    onCambio,
    valor,
    isMulti,
    meta: { touched, error },
}) => {
    const invalid = touched && error;

    // Estilos personalizados para el react-select
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            borderRadius: "1.5rem",
            fontSize: "12px",
            minHeight: "0",
            border: state.isFocused ? "1px solid #035192" : "1px solid #ced4da",
            boxShadow: state.isFocused
                ? "0 0 0 0.2rem rgba(3, 81, 146, 0.25)"
                : "none",
        }),
        placeholder: (provided) => ({
            ...provided,
            fontSize: "14px",
        }),
        indicatorContainer: (provided) => ({
            ...provided,
            padding: "0 8px 0 2px",
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            backgroundColor: "white",
        }),
        singleValue: (provided) => ({
            ...provided,
            fontSize: "12px",
        }),
        menu: (provided) => ({
            ...provided,
            fontSize: "12px",
            zIndex: 9999,
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    };

    return (
        <React.Fragment>
            <AsyncSelect
                isClearable={isClearable}
                cacheOptions
                backspaceRemovesValue={false}
                isSearchable={isSearchable}
                defaultOptions
                loadOptions={loadOptions}
                placeholder={placeholder ? placeholder : "Seleccione..."}
                onChange={(e) => {
                    input.onChange(e ? e : null);
                    if (!!onCambio) {
                        onCambio(e ? e : null);
                    }
                }}
                value={input.value}
                isDisabled={disabled}
                getOptionValue={(option) => option[valueKey]}
                getOptionLabel={(option) => option[labelKey]}
                isMulti={isMulti}
                styles={customStyles}
                onBlur={() => {
                    input.onBlur(input.value);
                }}
                menuPortalTarget={document.body} // Renderiza el menú del select en el body
            />
            {invalid && <div className="invalid-force">{error}</div>}
        </React.Fragment>
    );
};
const AsyncSelectFields = ({
    input,
    disabled,
    isClearable,
    isSearchable,
    loadOptions,
    placeholder,
    meta: { touched, error },
}) => {
    const invalid = touched && error;
    return (
        <React.Fragment>
            <AsyncSelect
                isClearable={isClearable}
                cacheOptions
                className={classNames("react-select-container", {
                    "is-invalid": invalid,
                })}
                backspaceRemovesValue={false}
                isSearchable={isSearchable}
                defaultOptions
                loadOptions={loadOptions}
                placeholder={placeholder ? placeholder : "Seleccione..."}
                onChange={(e) => input.onChange(e ? e : null)}
                value={input.value}
                isDisabled={disabled}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </React.Fragment>
    );
};

export default AsyncSelectFields;

export const AsyncSelectFieldFinca = ({
    input,
    disabled,
    isClearable,
    isSearchable,
    loadOptions,
    placeholder,
    valueKey,
    labelKey,
    onCambio,
    valor,
    isMulti,
    meta: { touched, error },
}) => {
    const invalid = touched && error;
    return (
        <React.Fragment>
            <Async
                isClearable={isClearable}
                cacheOptions
                className={classNames("react-select-container", {
                    "is-invalid": invalid,
                })}
                backspaceRemovesValue={false}
                isSearchable={isSearchable}
                defaultOptions
                loadOptions={loadOptions}
                placeholder={placeholder ? placeholder : "Seleccione..."}
                onChange={(e) => {
                    input.onChange(e ? e : null);
                    if (!!onCambio) {
                        onCambio(e ? e : null);
                    }
                }}
                value={input.value}
                isDisabled={disabled}
                getOptionValue={(option) => option[valueKey]}
                getOptionLabel={(option) =>
                    `${option["nombre"]} - ${option["razon_social"]}`
                }
                isMulti={isMulti}
            />
            {invalid && <div className="invalid-force">{error}</div>}
        </React.Fragment>
    );
};

export const CreatableSelectField = ({
    input,
    disabled,
    isClearable,
    isSearchable,
    options,
    placeholder,
    labelKey = "label",
    valueKey = "value",
    meta: { touched, error },
}) => {
    const invalid = touched && error;
    const _options = [];
    options.forEach((option) => {
        _options.push({
            ...option,
            label: option[labelKey],
            value: option[valueKey],
        });
    });

    return (
        <React.Fragment>
            <Creatable
                isClearable={isClearable}
                className={classNames("react-select-container", {
                    "is-invalid": invalid,
                })}
                backspaceRemovesValue={false}
                isSearchable={isSearchable}
                options={_options}
                placeholder={placeholder}
                onChange={(e) => {
                    input.onChange(e ? e : null);
                }}
                value={input.value}
                isDisabled={disabled}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </React.Fragment>
    );
};

/**
 * @param photo: este parametro se usa para tener la imagen previa de una imagen en dado caso el formulario es
 * usado para una actualizacion, se espera que sea la ruta donde se encuentra la imagen
 * @param setFile
 * @param className
 * @param disabled
 * @param input
 * @param touched
 * @param error
 * */
export const renderFilePicker = ({
    photo,
    setFile,
    className,
    disabled,
    input,
    meta: { touched, error },
}) => {
    const invalid = touched && error;
    return (
        <div className={classNames(`${className}`, { "is-invalid": invalid })}>
            <FileUploader
                disabled={disabled}
                img={!!photo ? photo : null}
                onFileChange={(e, file) => {
                    file = file || e.target.files[0];
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        input.onChange(reader.result);
                        if (!!setFile) {
                            setFile(file);
                        }
                    };
                    reader.readAsDataURL(file);
                }}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderDayPicker = ({
    className,
    disabled,
    maxDate,
    minDate,
    input,
    meta: { touched, error },
}) => {
    const invalid = touched && error;
    return (
        <div className={classNames(`${className}`, { "is-invalid": invalid })}>
            <DayPicker
                disabled={disabled}
                maxDate={maxDate}
                minDate={minDate}
                onChange={(e) => input.onChange(e)}
                value={input.value}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderDatePicker = ({
    className,
    disabled,
    onCambio,
    maxDate,
    minDate,
    todayButton,
    addClass,
    dateFormat,
    placeholder,
    showPopperArrow,
    fecha_inicial,
    input,
    meta: { touched, error },
}) => {
    const invalid = touched && error;
    return (
        <div className={classNames(`${className}`, { "is-invalid": invalid })}>
            <DatePicker
                showPopperArrow={showPopperArrow ? showPopperArrow : false}
                dateFormat={dateFormat ? dateFormat : "DD/MM/YYYY"}
                placeholderText={placeholder}
                onChange={(e) => {
                    input.onChange(e);
                    if (!!onCambio) {
                        onCambio(e);
                    }
                }}
                selected={input.value ? moment(input.value) : fecha_inicial}
                disabled={disabled}
                maxDate={maxDate}
                minDate={minDate}
                todayButton={todayButton}
                className={classNames(
                    "form-control",
                    { "is-invalid": invalid },
                    addClass
                )}
            />
            {invalid && <div className="invalid-force">{error}</div>}
        </div>
    );
};

export const renderTimeField = ({
    required,
    name,
    className,
    input,
    label,
    disabled,
    type,
    meta: { touched, error },
}) => {
    const valueIsValid = (value) => {
        if (value instanceof Date) {
            return true;
        }
        return (
            value &&
            value.length === 5 &&
            value.match(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/)
        );
    };
    const invalid = touched && error;
    return (
        <div className={classNames({ "is-invalid": invalid })}>
            <TimePicker
                maxDetail="minute"
                locale="en-US"
                disableClock={true}
                clearIcon={null}
                name={name}
                value={input.value}
                onChange={(value) => {
                    if (valueIsValid(value)) {
                        input.onChange(value);
                    }
                }}
                disabled={disabled}
            />
            {invalid && <div className="invalid-force">{error}</div>}
        </div>
    );
};

export const renderTagsInput = ({ input, placeholder }) => {
    const keys = [9, 13, 32];
    return (
        <TagsInput
            value={input.value ? input.value : []}
            onChange={(value) => {
                input.onChange(value);
            }}
            addKeys={keys}
            inputProps={{
                className: "form-control-inline",
                placeholder: placeholder,
            }}
        />
    );
};

export const renderTypeOfDebtDisabled = ({
    input,
    placeholder,
    type,
    meta: { touched, error },
    applyStyles = true,
    isTextarea = true,
    labels = {}, // Recibe las etiquetas como parámetro opcional
}) => {
    const invalid = touched && error;

    // Si `labels` está presente y tiene un valor para el input, mostramos la etiqueta
    const label = labels[input.value] || null;

    const commonStyles = {
        border: "0",
        overflow: "hidden",
        resize: "none",
        height: "auto",
        
    };

    const inputProps = {
        ...input,
        placeholder,
        type,
        className: classNames("form-control-disabled", {
            "is-invalid": invalid,
        }),
        disabled: true,
    };

    return (
        <div>
            {label ? (
                // Mostrar el valor mapeado (label) en lugar del textarea o input si existe
                <input
                    value={label}
                    type="text"
                    className={inputProps.className}
                    disabled={true}
                    style={
                        applyStyles
                            ? {
                                  ...commonStyles,
                                  textTransform: "uppercase",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                              }
                            : { border: "0" }
                    }
                />
            ) : // Si no hay etiqueta, renderizamos el textarea o input deshabilitado
            isTextarea ? (
                <textarea
                    {...inputProps}
                    style={applyStyles ? commonStyles : { border: "0" }}
                />
            ) : (
                <input
                    {...inputProps}
                    style={
                        applyStyles
                            ? commonStyles
                            : {
                                  border: "0",
                                  textTransform: "uppercase",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                              }
                    }
                />
            )}
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};
export const renderFieldDisabled = ({
    input,
    placeholder,
    meta: { touched, error },
    style,
    applyStyles = true,
}) => {
    const invalid = touched && error;
    
    // Estilos optimizados para forzar salto de línea y alineación izquierda con mejor espaciado
    const optimizedStyles = {
        border: "0",
        padding: "4px 6px", // Aumentado el padding para mejor espaciado
        textAlign: "left",
        display: "block",
        width: "100%",
        whiteSpace: "normal",
        wordWrap: "break-word",
        wordBreak: "break-word",
        overflow: "visible",
        minHeight: "24px", // Aumentado para evitar superposición
        marginBottom: "2px", // Margen inferior para separar elementos
        lineHeight: "1.3", // Mejor espaciado entre líneas
        fontSize: applyStyles ? "" : "13px",
        fontWeight: applyStyles ? "" : "bold",
        textTransform: applyStyles ? "none" : "uppercase",
        ...style, // Aplicar estilos pasados como parámetro
    };

    // Usar un div en lugar de input para mejor manejo de texto con saltos de línea
    return (
        <div style={{ 
            textAlign: "left", 
            width: "100%", 
            marginBottom: "4px", // Margen adicional en el contenedor
        }}>
            <div
                className={classNames("form-control-disabled text-left", {
                    "is-invalid": invalid,
                })}
                style={optimizedStyles}
            >
                {input.value || placeholder || ""}
            </div>
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderDollarDisabled = ({
    input,
    placeholder,
    type,
    meta: { touched, error },
    disabledStyle,
    decimalScale,
}) => {
    const invalid = touched && error;
    const scale =
        decimalScale !== undefined && decimalScale !== null ? decimalScale : 2;
    return (
        <div style={{ textAlign: "right" }}>
            <NumberFormat
                {...input}
                placeholder={placeholder}
                style={{
                    border: "0",
                    ...disabledStyle,
                    minWidth: "100px",
                    whiteSpace: "nowrap",
                }}
                prefix="$ "
                thousandSeparator
                fixedDecimalScale
                decimalScale={scale}
                className={classNames("form-control-disabled", {
                    "is-invalid": invalid,
                })}
                displayType="text"
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};
export const renderDollarDisabledWhithNegative = ({
    input,
    placeholder,
    type,
    meta: { touched, error },
    decimalScale,
    highlightNegative = false
}) => {
    const invalid = touched && error;
    const scale =
        decimalScale !== undefined && decimalScale !== null ? decimalScale : 2;
    const isNegative = highlightNegative && parseFloat(input.value) < 0;
    return (
        <div style={{ textAlign: "right" }}>
            <NumberFormat
                {...input}
                placeholder={placeholder}
                style={{
                    border: "0",
                    color: isNegative ? "red" : undefined,
                    minWidth: "100px",
                    whiteSpace: "nowrap",
                }}
                prefix="$ "
                thousandSeparator
                fixedDecimalScale
                decimalScale={scale}
                displayType="text"
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderNumberSinFormatoDisabled = ({
    input,
    placeholder,
    type,
    meta: { touched, error },
    Decimals = true,
}) => {
    const invalid = touched && error;
    return (
        <div>
            <NumberFormat
                {...input}
                placeholder={placeholder}
                type={type}
                style={{ border: "0", textAlign: "center" }}
                // prefix = {"$"}
                thousandSeparator
                fixedDecimalScale={Decimals}
                decimalScale={2}
                className={classNames("form-control-disabled", {
                    "is-invalid": invalid,
                })}
                disabled
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export const renderQuetzalesDisabled = ({
    input,
    placeholder,
    type,
    decimalScale,
    meta: { touched, error },
    disabledStyle,
    highlightNegative = false
}) => {
    const invalid = touched && error;
    const scale =
        decimalScale !== undefined && decimalScale !== null ? decimalScale : 2;
    const isNegative = highlightNegative && parseFloat(input.value) < 0;
    
    return (
        <div style={{ textAlign: "right" }}>
            <NumberFormat
                {...input}
                placeholder={placeholder}
                type={type}
                thousandSeparator
                decimalScale={scale}
                fixedDecimalScale
                prefix="Q "
                displayType="text"
                style={{
                    border: "0",
                    ...disabledStyle,
                    minWidth: "100px",
                    whiteSpace: "nowrap",
                    textAlign: "right",
                    color: isNegative ? "red" : undefined
                }}
                className={classNames("form-control-disabled", {
                    "is-invalid": invalid,
                })}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};
export const renderPercentageDisabled = ({
    input,
    placeholder,
    type,
    meta: { touched, error },
    style,
}) => {
    const invalid = touched && error;
    const defaultStyles = { border: "0", textAlign: "right" };
    const combinedStyles = style ? { ...style } : defaultStyles;
    return (
        <div>
            <NumberFormat
                {...input}
                placeholder={placeholder}
                type={type}
                style={combinedStyles}
                thousandSeparator
                decimalScale={2}
                fixedDecimalScale
                suffix=" %"
                className={classNames("form-control-disabled", {
                    "is-invalid": invalid,
                })}
                disabled
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};
export const renderFieldCheckCompact = ({
    input,
    label,
    disabled,
    onChange,
    meta: { touched, error },
}) => {
    return (
        <label className="needsclick" style={{ 
            display: 'inline-flex', 
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto',
            padding: 0,
            whiteSpace: 'normal',
            overflow: 'visible',
            position: 'relative'
        }}>
            <input
                type="checkbox"
                disabled={disabled}
                {...input}
                checked={input.value ? true : false}
                style={{ 
                    margin: 0,
                    opacity: 0,
                    position: 'absolute',
                    zIndex: 1
                }}
            />
            <span style={{ 
                display: 'inline-block',
                width: '18px', 
                height: '18px', 
                backgroundColor: input.value ? '#006400' : '#fff',
                border: '1px solid #006400',
                borderRadius: '2px',
                position: 'relative'
            }}>
                {input.value && (
                    <span className="fa fa-check" style={{ 
                        color: 'white', 
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        fontSize: '12px'
                    }} />
                )}
            </span>
            {label && <span style={{ marginLeft: '5px' }}>{label}</span>}
        </label>
    );
};
export const RenderField = {
    renderField,
    renderTextArea,
    renderNumber,
    renderCurrency,
    renderSwitch,
    renderSwitchMessage,
    renderFieldCheck,
    renderFieldRadio,
    renderCM2,
    renderTimeField,
    renderFieldDisabled,
    renderQuetzalesDisabled,
    renderDollarDisabled,
    renderPercentageDisabled,
    renderNumberUnits,
    renderTypeOfDebtDisabled,
    renderFieldCheckCompact
};

// Componentes personalizados para flujo de caja con colores automáticos
export const CustomCurrencyDisabled = ({ input, meta, isSalida, currency, placeholder }) => {
    const value = parseFloat(input.value) || 0;
    const isNegative = isSalida || value < 0;
    const absValue = Math.abs(value);
    
    // Formatear con paréntesis si es negativo
    const formattedValue = isNegative ? `(Q. ${absValue.toLocaleString('es-GT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})` : `Q. ${absValue.toLocaleString('es-GT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    const style = isNegative ? { color: '#dc3545', fontWeight: '500' } : {};
    
    return (
        <div style={{ textAlign: "right" }}>
            <div
                style={{
                    border: "0",
                    ...style,
                    minWidth: "100px",
                    whiteSpace: "nowrap",
                    padding: "0.375rem 0.75rem",
                    background: "transparent"
                }}
                className="form-control-disabled"
            >
                {formattedValue}
            </div>
        </div>
    );
};

export const CustomDollarDisabled = ({ input, meta, isSalida, currency, placeholder }) => {
    const value = parseFloat(input.value) || 0;
    const isNegative = isSalida || value < 0;
    const absValue = Math.abs(value);
    
    // Formatear con paréntesis si es negativo
    const formattedValue = isNegative ? `($ ${absValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})` : `$ ${absValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    const style = isNegative ? { color: '#dc3545', fontWeight: '500' } : {};
    
    return (
        <div style={{ textAlign: "right" }}>
            <div
                style={{
                    border: "0",
                    ...style,
                    minWidth: "100px",
                    whiteSpace: "nowrap",
                    padding: "0.375rem 0.75rem",
                    background: "transparent"
                }}
                className="form-control-disabled"
            >
                {formattedValue}
            </div>
        </div>
    );
};


